import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

const testimonials = [
{
  id: 'testimonial_1',
  name: 'Sarah Johnson',
  role: 'E-commerce Manager',
  company: 'TechGear Store',
  rating: 5,
  text: 'ShipTrack has transformed our international shipping. The country-specific tracking codes give our customers complete transparency, and the delivery times are consistently excellent.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ed4c1572-1763295037377.png",
  alt: 'Portrait of Sarah Johnson, E-commerce Manager with blonde hair and professional attire'
},
{
  id: 'testimonial_2',
  name: 'Michael Chen',
  role: 'Logistics Director',
  company: 'Global Imports Inc',
  rating: 5,
  text: 'The multilingual support and real-time tracking have been game-changers for our business. We ship to 50+ countries and ShipTrack handles it all seamlessly.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b1db1739-1763296537435.png",
  alt: 'Portrait of Michael Chen, Logistics Director with glasses and business suit'
},
{
  id: 'testimonial_3',
  name: 'Emily Rodriguez',
  role: 'Operations Manager',
  company: 'Fashion Forward',
  rating: 5,
  text: 'Customer support is outstanding! The AI chatbot answers questions instantly, and when we need human help, the team is always available. Highly recommended.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a6dc13ac-1763295391605.png",
  alt: 'Portrait of Emily Rodriguez, Operations Manager with curly hair and friendly smile'
}];


export default function TestimonialsSection() {
  return (
    <section className="py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-foreground mb-4">
            What Our Customers Say
          </h2>
          <p className="text-lg text-muted-foreground">
            Trusted by thousands of businesses worldwide
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials?.map((testimonial) =>
          <div
            key={testimonial?.id}
            className="bg-card rounded-xl p-6 border border-border hover:shadow-card-hover transition-all">
            
              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial?.rating)]?.map((_, i) =>
              <Icon key={i} name="StarIcon" size={20} className="text-amber-400" variant="solid" />
              )}
              </div>

              {/* Quote */}
              <p className="text-foreground mb-6 leading-relaxed">
                "{testimonial?.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-4 pt-4 border-t border-border">
                <div className="w-12 h-12 rounded-full overflow-hidden">
                  <AppImage
                  src={testimonial?.image}
                  alt={testimonial?.alt}
                  width={48}
                  height={48}
                  className="object-cover" />
                
                </div>
                <div>
                  <div className="font-semibold text-foreground">{testimonial?.name}</div>
                  <div className="text-sm text-muted-foreground">
                    {testimonial?.role}, {testimonial?.company}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

}